import React from 'react';
import { Card, CardContent, Typography, TextField, InputAdornment, Box } from '@mui/material';
import { Search as SearchIcon } from '@mui/icons-material';

interface PlayerSearchProps {
  searchTerm: string;
  onSearchChange: (term: string) => void;
}

const PlayerSearch: React.FC<PlayerSearchProps> = ({ searchTerm, onSearchChange }) => {
  return (
    <Card>
      <CardContent>
        <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>
          Search Players
        </Typography>
        
        <Box sx={{ position: 'relative' }}>
          <TextField
            fullWidth
            placeholder="Search by player name..."
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
        </Box>
      </CardContent>
    </Card>
  );
};

export default PlayerSearch;
